import CoreBreadcrumbNavigation from './BreadcrumbNavigation'
import { IBreadcrumbNavigation } from './model'
import CloseIconTemplate from './templates/CloseIconTemplate'

const BreadcrumbNavigation = CoreBreadcrumbNavigation as IBreadcrumbNavigation
BreadcrumbNavigation.CloseIconTemplate = CloseIconTemplate

export default BreadcrumbNavigation
